import { render, staticRenderFns } from "./ProcessingBatchBulkImport.vue?vue&type=template&id=081b21d2&scoped=true"
import script from "./ProcessingBatchBulkImport.vue?vue&type=script&lang=js"
export * from "./ProcessingBatchBulkImport.vue?vue&type=script&lang=js"
import style0 from "./ProcessingBatchBulkImport.vue?vue&type=style&index=0&id=081b21d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b21d2",
  null
  
)

export default component.exports